import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import DialogPanel from './DialogPanel';

export type Props = {
  message?: string;
};

const LazyLoading: FC<Props> = ({message = 'Loading...'}) => {
  return (
    <DialogPanel onClose={() => undefined} label={message} isOpen={true}>
      <Box sx={styles.content}>
        <CircularProgress sx={{mb: 2}} />
      </Box>
    </DialogPanel>
  );
};

export default LazyLoading;

const styles: Record<string, SxProps> = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 100,
    width: 300,
  },
};
